// extracted by mini-css-extract-plugin
export default {"UserContainer":"User_UserContainer__iZl27","UserEmpty":"User_UserEmpty__oLT9J"};